import { Sparkles } from 'lucide-react';
import type { AtoAprovado } from '../../types/atosAdministrativos';

type Props = {
  ato: AtoAprovado;
  onClick: () => void;
};

function truncate(text: string, max: number): string {
  if (text.length <= max) return text;
  return text.slice(0, max).trimEnd() + '…';
}

export default function AtoCard({ ato, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full text-left rounded-xl border border-navy-200 bg-white p-5 shadow-sm transition-all duration-200 hover:border-accent-500 hover:shadow-md hover:-translate-y-0.5 dark:border-navy-700 dark:bg-navy-900 dark:hover:border-accent-500"
    >
      <div className="flex items-start justify-between gap-2">
        <h3 className="text-base font-semibold text-navy-900 dark:text-navy-50 leading-snug">
          {ato.nome_ato}
        </h3>
        {ato.usou_perplexity && (
          <span className="flex-shrink-0 inline-flex items-center gap-1 rounded-full bg-accent-400/10 px-2 py-0.5 text-xs font-medium text-accent-600 dark:text-accent-400">
            <Sparkles className="h-3 w-3" />
            Perplexity
          </span>
        )}
      </div>

      <p className="mt-2 text-sm text-navy-600 dark:text-navy-400 leading-relaxed">
        {truncate(ato.descricao, 120)}
      </p>

    </button>
  );
}
